<template>
  <QBtn
    outline
    rounded
    dense
    color="primary"
    class="font-nunito payment-breakdown-button"
    :aria-label="label"
    v-bind="$attrs"
    @click="handleClick"
  >
    <QIcon :name="pieChartIcon" size="24px" class="payment-breakdown-button__icon q-mr-xs" />
    {{ label }}
  </QBtn>
</template>

<script>
import { QBtn, QIcon } from 'quasar';
import { evaPieChartOutline } from '@quasar/extras/eva-icons';
import {
  GTM_EVENT_NAME_SME_LEASE_CALCULATOR_CAR,
  GTM_EVENT_STAGE_VIEW_PAYMENT_BREAKDOWN,
  GTM_EVENT_VALUES_LEASE_CALCULATOR_CAR
} from '../../utils/constants';
import { formatWordsAsSentences } from '../../utils/calculator/wordFormatter';
import { formatVehicleDescription } from '../../utils/calculator/vehicleFormatter';

export default {
  name: 'PaymentBreakdownButton',
  inheritAttrs: false,
  components: { QBtn, QIcon },
  props: {
    label: {
      type: String,
      default: 'Payment breakdown'
    },
    vehicle: {
      type: Object,
      default: null
    },
    payCycle: {
      type: String,
      default: ''
    }
  },
  created() {
    this.pieChartIcon = evaPieChartOutline;
  },
  methods: {
    buildGtmData() {
      const vehicle = this.vehicle;
      if (!vehicle) {
        return { ...GTM_EVENT_VALUES_LEASE_CALCULATOR_CAR };
      }

      const model = `${formatWordsAsSentences(vehicle.vehicleModel)} ${vehicle.vehicleTrim || ''} |  ${
        vehicle.vehicleDrivetrain || ''
      }`.trim();
      const variant = formatVehicleDescription(vehicle)?.trim();
      const fuel = vehicle.vehicleFueltype || vehicle.vehiclePrimaryfueltype;

      return {
        ...GTM_EVENT_VALUES_LEASE_CALCULATOR_CAR,
        ...(vehicle?.vehicleMake?.length && { make: vehicle.vehicleMake }),
        ...(fuel?.length && { fuel }),
        ...(vehicle?.vehicleBodytype?.length && { type: vehicle.vehicleBodytype }),
        ...(model?.length && { model }),
        ...(variant?.length && { variant }),
        ...(this.payCycle?.length && { pay_cycle: this.payCycle }),
        ...(vehicle?.consumerPrice && { purchase_price: vehicle.consumerPrice })
      };
    },
    handleClick(event) {
      setTimeout(() => {
        this.$gtm.trackEvent({
          event: GTM_EVENT_NAME_SME_LEASE_CALCULATOR_CAR,
          stage: GTM_EVENT_STAGE_VIEW_PAYMENT_BREAKDOWN,
          data: this.buildGtmData()
        });
      });

      this.$emit('click', event);
    }
  }
};
</script>

<style lang="sass" scoped>
.payment-breakdown-button
  border-color: var(--q-color-primary) !important
  color: var(--q-color-primary) !important
  font-weight: 400
  font-size: 14px
  text-transform: none

.payment-breakdown-button:hover
  background: rgba(23, 68, 116, 0.08) !important

.payment-breakdown-button__icon
  flex-shrink: 0
</style>
